// Class: starling.filters.DisplacementMapFilter

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;
var $import = require("./../../import_stub").default;
var $extend = require("./../../extend_stub").default;
function starling_filters_FragmentFilter() {return require("./../../starling/filters/FragmentFilter");}
function starling_textures_SubTexture() {return require("./../../starling/textures/SubTexture");}
function starling_utils_Pool() {return require("./../../starling/utils/Pool");}
function starling_utils_RectangleUtil() {return require("./../../starling/utils/RectangleUtil");}
function starling_filters_DisplacementMapEffect() {return require("./../../starling/filters/DisplacementMapEffect");}
function starling_utils_MathUtil() {return require("./../../starling/utils/MathUtil");}
function openfl_geom_Rectangle() {return $import(require("openfl/geom/Rectangle"));}

// Constructor

var DisplacementMapFilter = function(mapTexture,componentX,componentY,scaleX,scaleY) {
	if(scaleY == null) {
		scaleY = 0.0;
	}
	if(scaleX == null) {
		scaleX = 0.0;
	}
	if(componentY == null) {
		componentY = 0;
	}
	if(componentX == null) {
		componentX = 0;
	}
	(starling_filters_FragmentFilter().default).call(this);
	this._mapX = this._mapY = 0;
	this._mapScaleX = this._mapScaleY = 1.0;
	this.set_mapTexture(mapTexture);
	this.set_componentX(componentX);
	this.set_componentY(componentY);
	this.set_scaleX(scaleX);
	this.set_scaleY(scaleY);
}

// Meta

DisplacementMapFilter.__name__ = "starling.filters.DisplacementMapFilter";
DisplacementMapFilter.__isInterface__ = false;
DisplacementMapFilter.__super__ = (starling_filters_FragmentFilter().default);
DisplacementMapFilter.prototype = $extend((starling_filters_FragmentFilter().default).prototype, {
	process: function(painter,pool,input0,input1,input2,input3) {
		var offsetX = 0.0;
		var offsetY = 0.0;
		var targetBounds = pool.get_targetBounds();
		var stage = pool.get_target().get_stage();
		if(stage != null && (targetBounds.x < 0 || targetBounds.y < 0)) {
			pool.get_target().getBounds(stage,DisplacementMapFilter.sBounds);
			DisplacementMapFilter.sBounds.inflate(this.get_padding().get_left(),this.get_padding().get_top());
			offsetX = DisplacementMapFilter.sBounds.x - pool.get_targetBounds().x;
			offsetY = DisplacementMapFilter.sBounds.y - pool.get_targetBounds().y;
		}
		this.updateVertexData(input0,this.get_mapTexture(),offsetX,offsetY);
		if(((this.get_mapTexture()) instanceof (starling_textures_SubTexture().default))) {
			var bounds = (starling_utils_Pool().default).getRectangle(0,0,1,1);
			(starling_utils_RectangleUtil().default).getBounds(bounds,this.get_mapTexture().get_transformationMatrixToRoot(),bounds);
			this.get_dispEffect().clampMapTexCoords(bounds.x,bounds.y,bounds.get_right(),bounds.get_bottom());
			(starling_utils_Pool().default).putRectangle(bounds);
		} else {
			this.get_dispEffect().clampMapTexCoords();
		}
		return (starling_filters_FragmentFilter().default).prototype.process.call(this,painter,pool,input0);
	},
	createEffect: function() {
		return new (starling_filters_DisplacementMapEffect().default)();
	},
	updateVertexData: function(inputTexture,mapTexture,mapOffsetX,mapOffsetY) {
		if(mapOffsetY == null) {
			mapOffsetY = 0.0;
		}
		if(mapOffsetX == null) {
			mapOffsetX = 0.0;
		}
		var mapWidth = (starling_utils_MathUtil().default).max(0.1,mapTexture.get_width() * this._mapScaleX);
		var mapHeight = (starling_utils_MathUtil().default).max(0.1,mapTexture.get_height() * this._mapScaleY);
		var mapX = (this._mapX + mapOffsetX + this.get_padding().get_left()) / mapWidth;
		var mapY = (this._mapY + mapOffsetY + this.get_padding().get_top()) / mapHeight;
		var maxU = inputTexture.get_width() / mapWidth;
		var maxV = inputTexture.get_height() / mapHeight;
		mapTexture.setTexCoords(this.get_vertexData(),0,"mapTexCoords",-mapX,-mapY);
		mapTexture.setTexCoords(this.get_vertexData(),1,"mapTexCoords",-mapX + maxU,-mapY);
		mapTexture.setTexCoords(this.get_vertexData(),2,"mapTexCoords",-mapX,-mapY + maxV);
		mapTexture.setTexCoords(this.get_vertexData(),3,"mapTexCoords",-mapX + maxU,-mapY + maxV);
	},
	updatePadding: function() {
		var paddingX = Math.ceil(Math.abs(this.get_dispEffect().get_scaleX()) / 2);
		var paddingY = Math.ceil(Math.abs(this.get_dispEffect().get_scaleY()) / 2);
		this.get_padding().setTo(paddingX,paddingX,paddingY,paddingY);
	},
	get_componentX: function() {
		return this.get_dispEffect().get_componentX();
	},
	set_componentX: function(value) {
		if(this.get_dispEffect().get_componentX() != value) {
			this.get_dispEffect().set_componentX(value);
			this.setRequiresRedraw();
		}
		return value;
	},
	get_componentY: function() {
		return this.get_dispEffect().get_componentY();
	},
	set_componentY: function(value) {
		if(this.get_dispEffect().get_componentY() != value) {
			this.get_dispEffect().set_componentY(value);
			this.setRequiresRedraw();
		}
		return value;
	},
	get_scaleX: function() {
		return this.get_dispEffect().get_scaleX();
	},
	set_scaleX: function(value) {
		if(this.get_dispEffect().get_scaleX() != value) {
			this.get_dispEffect().set_scaleX(value);
			this.updatePadding();
		}
		return value;
	},
	get_scaleY: function() {
		return this.get_dispEffect().get_scaleY();
	},
	set_scaleY: function(value) {
		if(this.get_dispEffect().get_scaleY() != value) {
			this.get_dispEffect().set_scaleY(value);
			this.updatePadding();
		}
		return value;
	},
	get_mapX: function() {
		return this._mapX;
	},
	set_mapX: function(value) {
		return this._mapX = value;
	},
	get_mapY: function() {
		return this._mapY;
	},
	set_mapY: function(value) {
		return this._mapY = value;
	},
	get_mapScaleX: function() {
		return this._mapScaleX;
	},
	set_mapScaleX: function(value) {
		this._mapScaleX = value;
		this.setRequiresRedraw();
		return value;
	},
	get_mapScaleY: function() {
		return this._mapScaleY;
	},
	set_mapScaleY: function(value) {
		this._mapScaleY = value;
		this.setRequiresRedraw();
		return value;
	},
	get_mapTexture: function() {
		return this.get_dispEffect().get_mapTexture();
	},
	set_mapTexture: function(value) {
		if(this.get_dispEffect().get_mapTexture() != value) {
			this.get_dispEffect().set_mapTexture(value);
			this.setRequiresRedraw();
		}
		return value;
	},
	get_mapRepeat: function() {
		return this.get_dispEffect().get_mapRepeat();
	},
	set_mapRepeat: function(value) {
		if(this.get_dispEffect().get_mapRepeat() != value) {
			this.get_dispEffect().set_mapRepeat(value);
			this.setRequiresRedraw();
		}
		return value;
	},
	get_dispEffect: function() {
		return this.get_effect();
	}
});
DisplacementMapFilter.prototype.__class__ = DisplacementMapFilter.prototype.constructor = $hxClasses["starling.filters.DisplacementMapFilter"] = DisplacementMapFilter;

// Init

Object.defineProperties(DisplacementMapFilter.prototype,{ componentX : { get : function () { return this.get_componentX (); }, set : function (v) { return this.set_componentX (v); }}, componentY : { get : function () { return this.get_componentY (); }, set : function (v) { return this.set_componentY (v); }}, scaleX : { get : function () { return this.get_scaleX (); }, set : function (v) { return this.set_scaleX (v); }}, scaleY : { get : function () { return this.get_scaleY (); }, set : function (v) { return this.set_scaleY (v); }}, mapX : { get : function () { return this.get_mapX (); }, set : function (v) { return this.set_mapX (v); }}, mapY : { get : function () { return this.get_mapY (); }, set : function (v) { return this.set_mapY (v); }}, mapScaleX : { get : function () { return this.get_mapScaleX (); }, set : function (v) { return this.set_mapScaleX (v); }}, mapScaleY : { get : function () { return this.get_mapScaleY (); }, set : function (v) { return this.set_mapScaleY (v); }}, mapTexture : { get : function () { return this.get_mapTexture (); }, set : function (v) { return this.set_mapTexture (v); }}, mapRepeat : { get : function () { return this.get_mapRepeat (); }, set : function (v) { return this.set_mapRepeat (v); }}});

// Statics


DisplacementMapFilter.sBounds = new (openfl_geom_Rectangle().default)()

// Export

exports.default = DisplacementMapFilter;